export interface Feature {
    featureId: number;
    featureName: string;
    featureIdentifier: string;
    featureDescription: string;
    message: string;
    status: number;
}

export interface Limit {
    entryLimitId: number;
    featureIdentifier: string;
    featureName: string;
    minimumAmount: number;
    maximumAmount: number;
    currency: string;
    startDate: string;
    endDate: string;
}

export interface Downtime {
    downtimeId: number;
    featureName: string;
    featureIdentifier: string;
    descriptionText: string;
    bannerMessage: string;
    startDate: string;
    endDate: string;
    status: number;
    actualEndDate: string;
    downtimeType: number;
}

export interface FeatureFlagsAndLimitsState {
    features: Feature[];
    limits: Limit[];
    downtime: Downtime | null;
}

export const initialFeatureFlagsAndLimitsInitialState: FeatureFlagsAndLimitsState = {
    features: [],
    limits: [],
    downtime: null
};
